import React, { useState } from 'react';
import { MenuList as Menu } from './components/index';
import EventDetail from './components/eventDetails';
import useStyles from "./style";
import { getStatusColor } from "./util";

const ListItem = React.memo(({
  eventItem,
  onPrimaryActionClickedCallback,
  onPublishClickedCallback,
  onUnarchiveCallback,
  ...rest
}) => {
  const classes = useStyles({ status: rest.status, getStatusColor });

  const handlePrimaryAction = (btnText) => {
    switch (rest.status.toLowerCase()) {
      case "archived":
        onUnarchiveCallback(eventItem);
        break;
      case "canceled":
        rest.onDuplicateClickedCallback(eventItem);
        break;
      default:
        onPrimaryActionClickedCallback(eventItem, btnText);
    }
  }

  return (
    <div className={classes.listroot}>
      <EventDetail
        classes={classes}
        eventItem={eventItem}
        handlePrimaryAction={handlePrimaryAction}
        {...rest}
      />
      <Menu
        eventItem={eventItem}
        {...rest}
      />
    </div>
  );
});




export default ListItem;
